// extracted by mini-css-extract-plugin
module.exports = {"homepage":"Home_homepage__wlzhd"};